import _slicedToArray from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _toConsumableArray from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _classCallCheck from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";

/**
 * @file Created on Thu Aug 16 2018
 * @author VBr, LZe
 */
import { BigNumberParser, BooleanParser, DateParser, EnumParser, NumberParser, OptionalDesc, StringParser, StringTrimParser, Utils } from '@logio/common-be-fe';
import { getDateFormat } from '../../../../shared/date/getDateFormat';
import { Key } from '../../../../shared/keyboard/Key';
import { CodeBookItemLayer } from '../../../../shared/transportLayers/code-book/CodeBookItemLayer';
import translate from '../../../i18n/translate';
import { EditorNames } from '../components/editors';
import { FilterNames } from '../components/filters';
import { RendererNames } from '../components/renderers';
import Comparators from "../components/comparators";
import Formatters from '../components/formatters';
export var ColumnGenerator =
/*#__PURE__*/
function () {
  function ColumnGenerator(schema) {
    _classCallCheck(this, ColumnGenerator);

    this.schema = schema;
    this.codebookItemLayer = new CodeBookItemLayer();
  }
  /**
   * Returns column definitions with correct editors, renderers and filters based on it's parser. But they can be overwritten...
   * You can specify custom renderer via the cellRendererFramework prop
   * @author LZe
   * @param columns Type independent column definitions
   */


  _createClass(ColumnGenerator, [{
    key: "getColumnDefinitions",
    value: function getColumnDefinitions(columns) {
      var _this = this;

      /** Filter columns
       * return only columns, that should be shown
       */
      var filteredColumns = columns.filter(function (column) {
        return !column.dontCreateColumn;
      });
      return filteredColumns.map(function (column) {
        if (!_this.schema.hasOwnProperty(column.field)) {
          throw new Error("Property ".concat(column.field, " does not exists in data description"));
        }

        var components;

        if (column.field) {
          components = _this.getComponents(column.field);
          column.field = _this.schema[column.field].description.nameKey; // Renderers, Editors and Filters don't play well together with the framework ones

          if ((column.cellRenderer || column.cellRendererFramework) && components.cellRenderer != null) {
            delete components.cellRenderer;
          }

          if ((column.cellEditor || column.cellEditorFramework) && components.cellEditor != null) {
            delete components.cellEditor;
          }

          if ((column.filter || column.filterFramework) && components.filter != null) {
            delete components.filter;
          }
          /* Allows translate boolean filter values from true / false to eg. active / archived */


          if (column.booleanFilterMap) {
            components.filterParams = {
              suppressMiniFilter: true,
              cellRenderer: function cellRenderer(params) {
                switch (params.value) {
                  case 'true':
                    return column.booleanFilterMap.true;

                  case 'false':
                    return column.booleanFilterMap.false;

                  default:
                    return params.value;
                }
              }
            };
          }

          if (column.tooltipComponent) {
            components.tooltipField = components.field;
          }
          /* Merge cellClass of the column with the cellClass of the components (if they're not a function) to an array of classes */


          if (column.cellClass && components.cellClass) {
            if (typeof column.cellClass !== 'function' && typeof components.cellClass !== 'function') {
              var componentsCellClassArray = Array.isArray(components.cellClass) ? components.cellClass : [components.cellClass];
              var columnCellClassArray = Array.isArray(column.cellClass) ? column.cellClass : [column.cellClass];
              column.cellClass = [].concat(_toConsumableArray(componentsCellClassArray), _toConsumableArray(columnCellClassArray));
            }
          }
        }

        return Object.assign(Object.assign({}, components), column);
      });
    }
    /**
     * Returns autogroup column definitions with correct filter types etc. based on it's parser
     * Omits editor and renderer because there are not wanted here
     */

  }, {
    key: "getAutoGroupColumnDefinitions",
    value: function getAutoGroupColumnDefinitions(column) {
      var columnDefinition = this.getColumnDefinitions([column])[0];
      columnDefinition.cellRendererParams = Object.assign(Object.assign({}, column.cellRendererParams), {
        innerRenderer: columnDefinition.cellRenderer
      });
      delete columnDefinition.cellRenderer;
      delete columnDefinition.field;
      return columnDefinition;
    }
    /**
     * Returns data paired to object's description nameKey used in column definitions
     * @param data Domain object or string mapping of fieldName: value pairs
     */

  }, {
    key: "getColumnData",
    value: function getColumnData(data) {
      var _this2 = this;

      var column = {};

      if (data) {
        Object.entries(data).forEach(function (_ref) {
          var _ref2 = _slicedToArray(_ref, 2),
              k = _ref2[0],
              v = _ref2[1];

          if (_this2.schema.hasOwnProperty(k)) {
            column[_this2.schema[k].description.nameKey] = v;
          }
        });
      }

      return column;
    }
    /**
     * Returns type dependat column properties based on columns parser
     */

  }, {
    key: "getComponents",
    value: function getComponents(field) {
      var propDescBase;

      if (this.schema[field] instanceof OptionalDesc) {
        propDescBase = this.schema[field].base;
      } else {
        propDescBase = this.schema[field];
      }

      var parser = propDescBase.parser.__proto__.constructor.name;
      var nameKey = this.schema[field].description.nameKey;
      var nameKeySimple = this.schema[field].simpleNameKey();
      var defaultDefinitions = {
        valueFormatter: Formatters.defaultFormatter,
        valueSetter: this.valueSetter,
        schema: this.schema[field],
        field: nameKey,
        fieldKey: nameKeySimple,
        colId: nameKey,
        headerName: translate(nameKey),
        suppressKeyboardEvent: function suppressKeyboardEvent(params) {
          var key = params.event.key;
          return params.editing && key === Key.Enter || params.editing && key === Key.Escape && params.context.store.invalid || params.editing && key === Key.Tab && params.context.store.invalid;
        },
        excel: {}
      };

      switch (parser) {
        case StringParser.name:
        case StringTrimParser.name:
          {
            return Object.assign(Object.assign({}, defaultDefinitions), {
              cellEditor: EditorNames.TextEditor,
              // filter: FilterNames.TextFilter,
              filter: 'agTextColumnFilter',
              filterParams: {
                clearButton: true
              },
              cellClassRules: {
                'ag-cell-type-string': function agCellTypeString(_ref3) {
                  var value = _ref3.value;
                  return !Utils.isValueMissing(value);
                }
              }
            });
          }

        case BigNumberParser.name:
          {
            return Object.assign(Object.assign({}, defaultDefinitions), {
              cellEditor: EditorNames.NumberEditor,
              // filter: FilterNames.RangeFilter,
              filter: 'agNumberColumnFilter',
              filterValueGetter: function filterValueGetter(params) {
                return !Utils.isValueMissing(params.data[params.colDef.colId]) ? Number(params.data[params.colDef.colId]) : null;
              },
              filterParams: {
                clearButton: true
              },
              cellClassRules: {
                'ag-cell-type-number': function agCellTypeNumber(_ref4) {
                  var value = _ref4.value;
                  return !Utils.isValueMissing(value);
                }
              },
              excel: Object.assign(Object.assign({}, defaultDefinitions.excel), {
                valueFormatter: Formatters.excelNumberFormatter
              })
            });
          }

        case NumberParser.name:
          {
            return Object.assign(Object.assign({}, defaultDefinitions), {
              cellEditor: EditorNames.NumberEditor,
              // filter: FilterNames.RangeFilter,
              filter: 'agNumberColumnFilter',
              filterParams: {
                clearButton: true
              },
              cellClassRules: {
                'ag-cell-type-number': function agCellTypeNumber(_ref5) {
                  var value = _ref5.value;
                  return !Utils.isValueMissing(value);
                }
              },
              excel: Object.assign(Object.assign({}, defaultDefinitions.excel), {
                valueFormatter: Formatters.excelNumberFormatter
              })
            });
          }

        case BooleanParser.name:
          {
            return Object.assign(Object.assign({}, defaultDefinitions), {
              cellEditor: EditorNames.CheckBoxEditor,
              cellRenderer: RendererNames.CheckBoxRenderer,
              valueFormatter: null,
              comparator: Comparators.checkBoxComparator,
              // filter: FilterNames.CustomBooleanFilter,
              cellClassRules: {
                'ag-cell-type-boolean': function agCellTypeBoolean(_ref6) {
                  var value = _ref6.value;
                  return !Utils.isValueMissing(value);
                }
              }
            });
          }

        case DateParser.name:
          {
            return Object.assign(Object.assign({}, defaultDefinitions), {
              cellEditor: EditorNames.DateEditor,
              filter: FilterNames.DateFilter,
              valueFormatter: function valueFormatter(_ref7) {
                var value = _ref7.value;
                return value ? value.format(getDateFormat()) : undefined;
              },
              cellClassRules: {
                'ag-cell-type-date': function agCellTypeDate(_ref8) {
                  var value = _ref8.value;
                  return !Utils.isValueMissing(value);
                }
              }
            });
          }

        case EnumParser.name:
          {
            var options = [];

            if (propDescBase.description.lookup) {
              this.codebookItemLayer.loadLookup(propDescBase.description.lookup).then(function (response) {
                response.codeBooks.forEach(function (item) {
                  options.push({
                    label: item.title,
                    value: item.id
                  });
                });
              });
            }

            return Object.assign(Object.assign({}, defaultDefinitions), {
              cellEditor: EditorNames.SelectEditor,
              filter: 'agSetColumnFilter',
              filterParams: {
                clearButton: true
              },
              selectOptions: options,
              cellClassRules: {
                'ag-cell-type-enum': function agCellTypeEnum(_ref9) {
                  var value = _ref9.value;
                  return !Utils.isValueMissing(value);
                }
              }
            });
          }
        // case ListParser.name: {
        //   return {
        //     ...defaultDefinitions,
        //     filter: FilterNames.TextFilter,
        //   };
        // }

        default:
          {
            return defaultDefinitions;
          }
      }
    }
  }, {
    key: "valueSetter",
    value: function valueSetter(params) {
      if (params.oldValue !== params.newValue) {
        // Sets the rows field value
        params.data[params.colDef.field] = params.newValue;
        return true;
      } // no change, so no refresh needed


      return false;
    }
  }]);

  return ColumnGenerator;
}();